/**
 * What a person does with a schedule-block STAND-IN (a booking OfficeHub saved that AppSheet has not confirmed), in ONE place, so the
 * "needs a person" bar, the daily Chat card and the block window cannot drift apart (SCHED-YEAR-1; three copies drifted in review).
 *
 * FLAGGED (the queue gave up): the queue also flags cases where AppSheet MAY ALREADY HOLD the row (a lost reply, an unusable Row ID,
 * the unknown-outcome deadline), so the instruction is CONDITIONAL: check AppSheet, and book again only if it is not there. Book BEFORE
 * deleting the stand-in: a flagged entry is already closed and can never be sent, so deleting first buys nothing and takes the job off
 * every list (and the Duplicate prefill) before it is re-booked.
 *
 * WAITING (unsent past the stale limit, not flagged): still owed to AppSheet and WILL be booked when sending resumes. Booking it again
 * would double-book the technician, so it carries no re-book instruction.
 */
export const STAND_IN_FLAGGED_ACTION = 'Not confirmed: check AppSheet. Only if it is NOT there, book it again, then delete this stand-in.';
export const STAND_IN_WAITING_ACTION = 'Waiting to be sent: it will still be booked, do NOT book it again.';

/** The instruction for one stand-in: only a flagged one is ever re-booked. */
export function standInActionText(flagged: boolean): string {
  return flagged ? STAND_IN_FLAGGED_ACTION : STAND_IN_WAITING_ACTION;
}
